import IDealerCategoriesModel from "@/chipply/IDealerCategoriesModel";

export default class ListDealerCategoriesResults {
    public categories: Array<IDealerCategoriesModel> = [];
    public showDealerCategories = false;
}
